/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAccessAlarm from '../../../../../../Icon/IconAccessAlarm';
import IconAccessAlarms from '../../../../../../Icon/IconAccessAlarms';
import IconAccessTime from '../../../../../../Icon/IconAccessTime';
import IconAddAlarm from '../../../../../../Icon/IconAddAlarm';
import IconAirplanemodeActive from '../../../../../../Icon/IconAirplanemodeActive';
import IconAirplanemodeInactive from '../../../../../../Icon/IconAirplanemodeInactive';
import IconBattery20 from '../../../../../../Icon/IconBattery20';
import IconBattery30 from '../../../../../../Icon/IconBattery30';
import IconBattery50 from '../../../../../../Icon/IconBattery50';
import IconBattery60 from '../../../../../../Icon/IconBattery60';
import IconBattery80 from '../../../../../../Icon/IconBattery80';
import IconBattery90 from '../../../../../../Icon/IconBattery90';
import IconBatteryAlert from '../../../../../../Icon/IconBatteryAlert';
import IconBatteryCharging20 from '../../../../../../Icon/IconBatteryCharging20';
import IconBatteryCharging30 from '../../../../../../Icon/IconBatteryCharging30';
import IconBatteryCharging50 from '../../../../../../Icon/IconBatteryCharging50';
import IconBatteryCharging60 from '../../../../../../Icon/IconBatteryCharging60';
import IconBatteryCharging80 from '../../../../../../Icon/IconBatteryCharging80';
import IconBatteryCharging90 from '../../../../../../Icon/IconBatteryCharging90';
import IconBatteryChargingFull from '../../../../../../Icon/IconBatteryChargingFull';
import IconBatteryFull from '../../../../../../Icon/IconBatteryFull';
import IconBatteryStd from '../../../../../../Icon/IconBatteryStd';
import IconBatteryUnknown from '../../../../../../Icon/IconBatteryUnknown';
import IconBluetooth from '../../../../../../Icon/IconBluetooth';
import IconBluetoothConnected from '../../../../../../Icon/IconBluetoothConnected';
import IconBluetoothDisabled from '../../../../../../Icon/IconBluetoothDisabled';
import IconBluetoothSearching from '../../../../../../Icon/IconBluetoothSearching';
import IconBrightnessAuto from '../../../../../../Icon/IconBrightnessAuto';
import IconBrightnessHigh from '../../../../../../Icon/IconBrightnessHigh';
import IconBrightnessLow from '../../../../../../Icon/IconBrightnessLow';
import IconBrightnessMedium from '../../../../../../Icon/IconBrightnessMedium';
import IconDataUsage from '../../../../../../Icon/IconDataUsage';
import IconDeveloperMode from '../../../../../../Icon/IconDeveloperMode';
import IconDevices from '../../../../../../Icon/IconDevices';
import IconDvr from '../../../../../../Icon/IconDvr';
import IconGpsFixed from '../../../../../../Icon/IconGpsFixed';
import IconGpsNotFixed from '../../../../../../Icon/IconGpsNotFixed';
import IconGpsOff from '../../../../../../Icon/IconGpsOff';
import IconGraphicEq from '../../../../../../Icon/IconGraphicEq';
import IconLocationDisabled from '../../../../../../Icon/IconLocationDisabled';
import IconLocationSearching from '../../../../../../Icon/IconLocationSearching';
import IconNetworkCell from '../../../../../../Icon/IconNetworkCell';
import IconNetworkWifi from '../../../../../../Icon/IconNetworkWifi';
import IconNfc from '../../../../../../Icon/IconNfc';
import IconScreenLockLandscape from '../../../../../../Icon/IconScreenLockLandscape';
import IconScreenLockPortrait from '../../../../../../Icon/IconScreenLockPortrait';
import IconScreenLockRotation from '../../../../../../Icon/IconScreenLockRotation';
import IconScreenRotation from '../../../../../../Icon/IconScreenRotation';
import IconSdStorage from '../../../../../../Icon/IconSdStorage';
import IconSettingsSystemDaydream from '../../../../../../Icon/IconSettingsSystemDaydream';
import IconSignalCellular0Bar from '../../../../../../Icon/IconSignalCellular0Bar';
import IconSignalCellular1Bar from '../../../../../../Icon/IconSignalCellular1Bar';
import IconSignalCellular2Bar from '../../../../../../Icon/IconSignalCellular2Bar';
import IconSignalCellular3Bar from '../../../../../../Icon/IconSignalCellular3Bar';
import IconSignalCellular4Bar from '../../../../../../Icon/IconSignalCellular4Bar';
import IconSignalCellularConnectedNoInternet0Bar from '../../../../../../Icon/IconSignalCellularConnectedNoInternet0Bar';
import IconSignalCellularConnectedNoInternet1Bar from '../../../../../../Icon/IconSignalCellularConnectedNoInternet1Bar';
import IconSignalCellularConnectedNoInternet2Bar from '../../../../../../Icon/IconSignalCellularConnectedNoInternet2Bar';
import IconSignalCellularConnectedNoInternet3Bar from '../../../../../../Icon/IconSignalCellularConnectedNoInternet3Bar';
import IconSignalCellularConnectedNoInternet4Bar from '../../../../../../Icon/IconSignalCellularConnectedNoInternet4Bar';
import IconSignalCellularNoSim from '../../../../../../Icon/IconSignalCellularNoSim';
import IconSignalCellularNull from '../../../../../../Icon/IconSignalCellularNull';
import IconSignalCellularOff from '../../../../../../Icon/IconSignalCellularOff';
import IconSignalWifi0Bar from '../../../../../../Icon/IconSignalWifi0Bar';
import IconSignalWifi1Bar from '../../../../../../Icon/IconSignalWifi1Bar';
import IconSignalWifi1BarLock from '../../../../../../Icon/IconSignalWifi1BarLock';
import IconSignalWifi2Bar from '../../../../../../Icon/IconSignalWifi2Bar';
import IconSignalWifi2BarLock from '../../../../../../Icon/IconSignalWifi2BarLock';
import IconSignalWifi3Bar from '../../../../../../Icon/IconSignalWifi3Bar';
import IconSignalWifi3BarLock from '../../../../../../Icon/IconSignalWifi3BarLock';
import IconSignalWifi4Bar from '../../../../../../Icon/IconSignalWifi4Bar';
import IconSignalWifi4BarLock from '../../../../../../Icon/IconSignalWifi4BarLock';
import IconSignalWifiOff from '../../../../../../Icon/IconSignalWifiOff';
import IconStorage from '../../../../../../Icon/IconStorage';
import IconUsb from '../../../../../../Icon/IconUsb';
import IconWallpaper from '../../../../../../Icon/IconWallpaper';
import IconWidgets from '../../../../../../Icon/IconWidgets';
import IconWifiLock from '../../../../../../Icon/IconWifiLock';
import IconWifiTethering from '../../../../../../Icon/IconWifiTethering';

export default function DeviceIcons() {
  return (
    <div>
      <CategoryHeader>device</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAccessAlarm size="32"/>
          <FigCaption>
            IconAccessAlarm
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAccessAlarms size="32"/>
          <FigCaption>
            IconAccessAlarms
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAccessTime size="32"/>
          <FigCaption>
            IconAccessTime
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAddAlarm size="32"/>
          <FigCaption>
            IconAddAlarm
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirplanemodeActive size="32"/>
          <FigCaption>
            IconAirplanemodeActive
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirplanemodeInactive size="32"/>
          <FigCaption>
            IconAirplanemodeInactive
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBattery20 size="32"/>
          <FigCaption>
            IconBattery20
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBattery30 size="32"/>
          <FigCaption>
            IconBattery30
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBattery50 size="32"/>
          <FigCaption>
            IconBattery50
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBattery60 size="32"/>
          <FigCaption>
            IconBattery60
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBattery80 size="32"/>
          <FigCaption>
            IconBattery80
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBattery90 size="32"/>
          <FigCaption>
            IconBattery90
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryAlert size="32"/>
          <FigCaption>
            IconBatteryAlert
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryCharging20 size="32"/>
          <FigCaption>
            IconBatteryCharging20
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryCharging30 size="32"/>
          <FigCaption>
            IconBatteryCharging30
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryCharging50 size="32"/>
          <FigCaption>
            IconBatteryCharging50
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryCharging60 size="32"/>
          <FigCaption>
            IconBatteryCharging60
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryCharging80 size="32"/>
          <FigCaption>
            IconBatteryCharging80
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryCharging90 size="32"/>
          <FigCaption>
            IconBatteryCharging90
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryChargingFull size="32"/>
          <FigCaption>
            IconBatteryChargingFull
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryFull size="32"/>
          <FigCaption>
            IconBatteryFull
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryStd size="32"/>
          <FigCaption>
            IconBatteryStd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBatteryUnknown size="32"/>
          <FigCaption>
            IconBatteryUnknown
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBluetooth size="32"/>
          <FigCaption>
            IconBluetooth
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBluetoothConnected size="32"/>
          <FigCaption>
            IconBluetoothConnected
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBluetoothDisabled size="32"/>
          <FigCaption>
            IconBluetoothDisabled
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBluetoothSearching size="32"/>
          <FigCaption>
            IconBluetoothSearching
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightnessAuto size="32"/>
          <FigCaption>
            IconBrightnessAuto
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightnessHigh size="32"/>
          <FigCaption>
            IconBrightnessHigh
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightnessLow size="32"/>
          <FigCaption>
            IconBrightnessLow
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrightnessMedium size="32"/>
          <FigCaption>
            IconBrightnessMedium
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDataUsage size="32"/>
          <FigCaption>
            IconDataUsage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDeveloperMode size="32"/>
          <FigCaption>
            IconDeveloperMode
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDevices size="32"/>
          <FigCaption>
            IconDevices
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDvr size="32"/>
          <FigCaption>
            IconDvr
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGpsFixed size="32"/>
          <FigCaption>
            IconGpsFixed
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGpsNotFixed size="32"/>
          <FigCaption>
            IconGpsNotFixed
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGpsOff size="32"/>
          <FigCaption>
            IconGpsOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGraphicEq size="32"/>
          <FigCaption>
            IconGraphicEq
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocationDisabled size="32"/>
          <FigCaption>
            IconLocationDisabled
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocationSearching size="32"/>
          <FigCaption>
            IconLocationSearching
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNetworkCell size="32"/>
          <FigCaption>
            IconNetworkCell
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNetworkWifi size="32"/>
          <FigCaption>
            IconNetworkWifi
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNfc size="32"/>
          <FigCaption>
            IconNfc
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconScreenLockLandscape size="32"/>
          <FigCaption>
            IconScreenLockLandscape
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconScreenLockPortrait size="32"/>
          <FigCaption>
            IconScreenLockPortrait
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconScreenLockRotation size="32"/>
          <FigCaption>
            IconScreenLockRotation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconScreenRotation size="32"/>
          <FigCaption>
            IconScreenRotation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSdStorage size="32"/>
          <FigCaption>
            IconSdStorage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSettingsSystemDaydream size="32"/>
          <FigCaption>
            IconSettingsSystemDaydream
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellular0Bar size="32"/>
          <FigCaption>
            IconSignalCellular0Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellular1Bar size="32"/>
          <FigCaption>
            IconSignalCellular1Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellular2Bar size="32"/>
          <FigCaption>
            IconSignalCellular2Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellular3Bar size="32"/>
          <FigCaption>
            IconSignalCellular3Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellular4Bar size="32"/>
          <FigCaption>
            IconSignalCellular4Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellularConnectedNoInternet0Bar size="32"/>
          <FigCaption>
            IconSignalCellularConnectedNoInternet0Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellularConnectedNoInternet1Bar size="32"/>
          <FigCaption>
            IconSignalCellularConnectedNoInternet1Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellularConnectedNoInternet2Bar size="32"/>
          <FigCaption>
            IconSignalCellularConnectedNoInternet2Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellularConnectedNoInternet3Bar size="32"/>
          <FigCaption>
            IconSignalCellularConnectedNoInternet3Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellularConnectedNoInternet4Bar size="32"/>
          <FigCaption>
            IconSignalCellularConnectedNoInternet4Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellularNoSim size="32"/>
          <FigCaption>
            IconSignalCellularNoSim
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellularNull size="32"/>
          <FigCaption>
            IconSignalCellularNull
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalCellularOff size="32"/>
          <FigCaption>
            IconSignalCellularOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifi0Bar size="32"/>
          <FigCaption>
            IconSignalWifi0Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifi1Bar size="32"/>
          <FigCaption>
            IconSignalWifi1Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifi1BarLock size="32"/>
          <FigCaption>
            IconSignalWifi1BarLock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifi2Bar size="32"/>
          <FigCaption>
            IconSignalWifi2Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifi2BarLock size="32"/>
          <FigCaption>
            IconSignalWifi2BarLock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifi3Bar size="32"/>
          <FigCaption>
            IconSignalWifi3Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifi3BarLock size="32"/>
          <FigCaption>
            IconSignalWifi3BarLock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifi4Bar size="32"/>
          <FigCaption>
            IconSignalWifi4Bar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifi4BarLock size="32"/>
          <FigCaption>
            IconSignalWifi4BarLock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSignalWifiOff size="32"/>
          <FigCaption>
            IconSignalWifiOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStorage size="32"/>
          <FigCaption>
            IconStorage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconUsb size="32"/>
          <FigCaption>
            IconUsb
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWallpaper size="32"/>
          <FigCaption>
            IconWallpaper
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWidgets size="32"/>
          <FigCaption>
            IconWidgets
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWifiLock size="32"/>
          <FigCaption>
            IconWifiLock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWifiTethering size="32"/>
          <FigCaption>
            IconWifiTethering
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/DeviceIcons.js